module.exports = __webpack_public_path__ + "static/media/icon_08.c56728ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_08.png
// module id = 1649
// module chunks = 1